import { render, staticRenderFns } from "./Custom.vue?vue&type=template&id=5a8a1b77&scoped=true&"
import script from "./Custom.vue?vue&type=script&lang=js&"
export * from "./Custom.vue?vue&type=script&lang=js&"
import style0 from "./Custom.vue?vue&type=style&index=0&id=5a8a1b77&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a8a1b77",
  null
  
)

export default component.exports